<template>
  <AppMenu v-if="showMenu" />
  <router-view />
  <ToastContainer />
</template>

<script setup lang="ts">
import AppMenu from '@/components/menu/AppMenu.vue'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import ToastContainer from './components/shared/toastContainer.vue';
import { useStore } from 'vuex'
const route = useRoute()
const showMenu = computed(() => !route.meta.hideMenu)
</script>

<style>
html {
  height: 100px;
  touch-action: manipulation;
}

body {
  height: 100%;
  touch-action: manipulation;
}
</style>
